import apiRequest from '@/utils/apiRequest';

export interface LoginForm {
  account: string;
  password: string;
  authCode?: string;
  googleCode?: string;
  deviceInfo?: string;
  deviceName?: string;
}

export interface RegisterForm {
  name: string;
  account: string;
  password: string;
  inviteCode?: string;
  deviceInfo?: string;
  deviceName?: string;
}

export interface LoginResponse {
  token: string;
  userId: number;
  account: string;
  name: string;
}

// 注册响应（支持待审核模式）
export interface RegisterResponse {
  userId: number;
  account: string;
  pendingReview: boolean;  // 是否待审核
}

export interface ChangePasswordForm {
  oldPassword: string;
  newPassword: string;
}

/**
 * 用户登录
 */
export async function login(data: LoginForm) {
  return apiRequest<LoginResponse>('/account/login', {
    method: 'POST',
    data,
    requestType: 'json',
  });
}

/**
 * 用户登出
 */
export async function logout() {
  return apiRequest<void>('/account/logout', {
    method: 'POST',
  });
}

/**
 * 用户注册
 */
export async function register(data: RegisterForm) {
  return apiRequest<RegisterResponse>('/account/register', {
    method: 'POST',
    data,
    requestType: 'json',
  });
}

/**
 * 修改密码
 */
export async function changePassword(data: ChangePasswordForm) {
  return apiRequest<void>('/account/changePassword', {
    method: 'POST',
    data,
    requestType: 'json',
  });
}

/**
 * 获取当前用户信息
 */
export async function getUserInfo() {
  return apiRequest<API.UserInfo>('/account/info', {
    method: 'POST',
  });
}

/**
 * 上传头像
 * @param base64Image 压缩后的 base64 图片（格式：data:image/jpeg;base64,...）
 * @returns 新的头像 URL
 */
export async function uploadAvatar(base64Image: string): Promise<string> {
  // 获取 token 和追踪码
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  const trackingCode = typeof window !== 'undefined' ? localStorage.getItem('trackingCode') : null;

  // 构建 URL
  const url = '/api/account/uploadAvatar';

  // 发送纯文本请求（后端使用 @RequestBody String 接收）
  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'text/plain',
      ...(token ? { token } : {}),
      ...(trackingCode ? { 'X-Tracking-Code': trackingCode } : {}),
    },
    body: base64Image,
    credentials: 'include',
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.msg || errorData.message || `上传失败: ${response.status}`);
  }

  const result = await response.json();
  if (result.success === false) {
    throw new Error(result.msg || result.message || '上传失败');
  }

  return result.data;
}
